import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { DateTimePicker } from 'react-widgets'
import { isEmpty } from 'lodash'

import {
  Form, FormGroup, ControlLabel, FormControl, Checkbox, Modal
} from 'react-bootstrap'

import Button from '../components/Button.jsx'
import { getTripsList, getUsernames, getThisUsername } from '../selectors'
import { getStatusIcon } from '../trips/TripStatus.js'
import { str2date, date2str } from '../../lib/Tools'
import { getText } from '../lib/text.js'

const THIS_USER = "__THIS_USER__"
const SEPARATOR = "__SEPARATOR__"
const inlineDateWrapperStyle = { display: "inline-block", maxWidth: 140, marginLeft: 10, marginRight: 20, marginBottom: 5}

/**
 *
 */

type FieldProps = {
  label: string,
  value: string,
  onChange: string => void,
  width: ?number
}

const Field = ({ label, value, onChange, width }: FieldProps) => (
  // options: options: { value: ?string, label: string }[]
  <FormGroup style={{display: "block", marginTop: 5}}>
    <ControlLabel style={{marginRight: 15, width: 55}}>{label}</ControlLabel>
    <FormControl
      type="text"
      value={value}
      style={width ? { width } : {}}
      onChange={evt => onChange(evt.target.value)}
    />
  </FormGroup>
)

/**
 *
 */

type SelectProps = {
  label: string,
  value: string,
  onChange: string => void,
  options: { value: string, label: string }[]
}

const Select = ({ label, value, onChange, options }: SelectProps) => (
  // options: options: { value: ?string, label: string }[]
  <FormGroup style={{display: "block", marginTop: 5}}>
    <ControlLabel style={{marginRight: 15, width: 55}}>{label}</ControlLabel>
    <FormControl
      componentClass="select"
      value={value}
      onChange={evt => onChange(evt.target.value)}
      style={{ maxWidth: 300 }}
    >
      {
        options.map(option => (
          option.value === SEPARATOR
            ? (<option disabled >──────</option>)
            : (<option key={option.value} value={option.value}>{option.label}</option>)
        ))
      }
    </FormControl>
  </FormGroup>
)

/**
 *
 */

type TEProps = {
  task: Object,
  onChange: (string, any) => void | Object => void,
  onRemove: () => void,
  onClose: () => void,

  trips: Object[],
  users: string[],
  thisUser: string,
}


class ModalTaskEditor extends React.PureComponent
{
  constructor(props) {
    super(props)
    this.state = {} // holds the changes made to the task
  }

  props: TEProps

  onChange(changes) {
    this.setState(changes)
  }

  onSave() {
    this.props.onChange(this.state)
  }

  thereAreChanges() {
    return !isEmpty(this.state)
  }

  render() {
    const { onRemove, trips, users, thisUser } = this.props

    const task = { ...this.props.task, ...this.state }

    return (
      <Modal show onHide={() => this.props.onClose()}>
        <Modal.Header>
          <Modal.Title>Editar tarea</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form inline>
            <Field
              label={getText("Texto")}
              value={task.text}
              width={300}
              onChange={v => this.onChange({ text: v })}
            />
            <Select
              label={getText("Usuario")}
              value={task.user}
              onChange={v => this.onChange({ user: v == THIS_USER ? thisUser : v })}
              options={[
                { value: THIS_USER, label: getText("Yo") },
                { value: SEPARATOR },
                ...users.map(u => ({ value: u, label: u }))
              ]}
            />
            <Select
              label={getText("Cliente")}
              value={task.trip}
              onChange={v => this.onChange({ trip: v })}
              options={[
                { value: null, label: getText("Ninguno") },
                { value: SEPARATOR },
                ...(trips.map(t => ({
                  value: t._id,
                  label: `${getStatusIcon(t.status)} ${t.name || getText("Cliente sin nombre")}`
                })))
              ]}
            />

            <div style={{display: "block", marginTop: 6}}>
              <Checkbox
                checked={!!task.dueDate}
                onChange={evt => {
                  if (evt.target.checked) {
                    this.onChange({
                      x: getText("Habilitar"),
                      dueDate: task.previousDueDate || moment().add(1, "days").format("YYYY/MM/DD")
                    })
                  }
                  else {
                    this.onChange({ x: getText("Cancelar"), dueDate: null, previousDueDate: task.dueDate })
                  }
                }}
              >
                Fecha
              </Checkbox>
              <div style={inlineDateWrapperStyle}>
                <DateTimePicker
                  calendar
                  time={false}
                  format="YYYY/MM/DD"
                  value={(task.dueDate && str2date(task.dueDate)) || new Date()}
                  min={str2date(moment().format("YYYY/MM/DD"))}
                  onChange={d => this.onChange({ dueDate: date2str(d) })}
                  disabled={!task.dueDate}
                />
              </div>
            </div>

            <Button bsStyle="link" style={{color: "red"}} onClick={() => onRemove()}>
              {getText("Eliminar")}
            </Button>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          {
            this.thereAreChanges() && (
              <Button
                glyph="remove"
                bsStyle="link"
                onClick={() => this.props.onClose()}
              >
                Cancelar
              </Button>
            )
          }
          <Button
            glyph="ok"
            bsStyle="success"
            onClick={() => { this.onSave(); this.props.onClose() }}
          >
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

const mapStateToProps = (state, props) => ({
  users: getUsernames(state, props),
  thisUser: getThisUsername(state, props),
  trips: getTripsList(state, props),
})

export default connect(mapStateToProps)(ModalTaskEditor)
